export default "__VITE_ASSET__DapDXHmd__"